import React from "react";
import { t } from "i18next";
import { Result, Spin, Checkbox, Button } from 'antd';
import moment from "moment";
import { Util } from "common/util";
import { getPayrolls } from "services/payroll_report";
import { getMany as getPayrollItems } from "services/payroll_item";
import withDataTable from "../../withDataTable";

const pathName = "/reports/payroll/payrolls";
const columns = [
  {
    title: <div>No&deg;</div>,
    dataIndex: "no",
    key: "no",
    width: 100,
    align: "center",
    render: (no, record, index) => index + 1
  },
  {
    title: "Name",
    dataIndex: "employeeName",
    key: "employeeName"
  },
  {
    title: "EMP#",
    dataIndex: "employeeCode",
    key: "employeeCode"
  },
  {
    title: "Position",
    dataIndex: "position",
    key: "position"
  },
  {
    title: "Contract Type",
    dataIndex: "contractType",
    key: "contractType"
  },
  {
    title: "D.O.E",
    dataIndex: "joinDate",
    key: "joinDate",
    render: joinDate => moment(joinDate).format("DD/MM/YYYY")
  },
  {
    title: "Activity Code",
    dataIndex: "activityCode",
    key: "activityCode"
  },
  {
    title: "Pay Basic Total",
    dataIndex: "grossSalary",
    key: "grossSalary",
    align: "right",
    render: grossSalary => Util.getInstance().formatCurrency(grossSalary)
  },
  {
    title: "Taxable Salary",
    dataIndex: "taxableSalary",
    key: "taxableSalary",
    align: "right",
    render: (taxableSalary, record) => record.taxRate > 0 ? Util.getInstance().formatCurrency(taxableSalary) : ""
  },
  {
    title: "Net First Pay",
    dataIndex: "firstPayment",
    key: "firstPayment",
    align: "right",
    render: firstPayment => Util.getInstance().formatCurrency(firstPayment)
  },
  {
    title: "Net Second Pay",
    dataIndex: "secondPayment",
    key: "secondPayment",
    align: "right",
    render: secondPayment => Util.getInstance().formatCurrency(secondPayment)
  },
  {
    title: "Net Pay",
    dataIndex: "netPay",
    key: "netPay",
    align: "right",
    render: netPay => Util.getInstance().formatCurrency(netPay)
  },
];

const handleSearch = (e) => {
  const value = e.target.value;
  const params = new URLSearchParams(document.location.search);

  if (value) {
    params.set("search", value)
  } else {
    params.delete("search");
  }

  Util.getInstance().pushParamsToURL(pathName, params.toString());
};

const getData = () => {
  let option = {};
  const params = new URLSearchParams(document.location.search);
  if (params.has("startMonth")) option["startMonth"] = params.get("startMonth");
  if (params.has("endMonth")) option["endMonth"] = params.get("endMonth");
  if (params.has("search")) option["search"] = params.get("search");

  return new Promise((resolve, reject) => {
    getPayrolls(option)
      .then(response => resolve(response.data))
      .catch(error => reject(error));
  });

};

const componentWillMount = () => {
  const params = new URLSearchParams(document.location.search);
  if (!params.get("startMonth") && !params.get("endMonth")) {
    params.set("startMonth", moment().format("YYYY-MM"));
    params.set("endMonth", moment().format("YYYY-MM"));
  }
  params.delete("payrollPeriod");
  params.delete("payrollElements");
  Util.getInstance().pushParamsToURL(pathName, params.toString());
};

function ExportFormLoader() {
  const [loading, setLoading] = React.useState(true);
  const [payrollItems, setPayrollItems] = React.useState([]);
  const [result, setResult] = React.useState(null);
  const [exportStep, setExportStep] = React.useState(null);
  const params = new URLSearchParams(document.location.search);

  const fetchReport = () => {
    const params = new URLSearchParams(document.location.search);
    let option = {};
    if (params.has("startMonth")) option["startMonth"] = params.get("startMonth");
    if (params.has("endMonth")) option["endMonth"] = params.get("endMonth");
    if (params.has("payrollPeriod")) option["payrollPeriod"] = params.get("payrollPeriod");
    if (params.has("search")) option["search"] = params.get("search");
    if (params.has("payrollElements")) option["payrollElements"] = params.get("payrollElements");

    option["isExport"] = true;
    setLoading(true);
    setExportStep(null);
    getPayrolls(option)
      .then((response) => {
        if (response) {
          setResult(response);
        }
      })
      .finally(() => setLoading(false));
  }

  React.useEffect(() => {
    const params = new URLSearchParams(document.location.search);
    if (params.get("payrollPeriod") === "first_payment") {
      fetchReport();
    } else {
      getPayrollItems({ limit: 0 })
      .then((response) => {
        if (response.data) {
          setPayrollItems(response.data);
          setExportStep("SELECT_PAYROLL_ITEM");
        }
      }).finally(() => setLoading(false));
    }

    return () => {
      params.delete("payrollPeriod");
      params.delete("payrollElements");
      setLoading(true);
      Util.getInstance().pushParamsToURL(pathName, params.toString());
    };
    // eslint-disable-next-line
  }, []);

  const onChange = (checkedValues) => {
    const params = new URLSearchParams(document.location.search);
    params.set("payrollElements", `${checkedValues}`);
    Util.getInstance().pushParamsToURL(pathName, params.toString());
  }

  return (
    <>
      {loading ? (
        <Spin
          spinning={loading}
          style={{
            height: "24vh",
            display: "flex",
            alignItems: "center",
          }}
        />
      ) : (
        exportStep === "SELECT_PAYROLL_ITEM" ? <>

          {
            params.get("payrollPeriod") === "second_payment" && 
            <Checkbox.Group
              style={{
                width: '100%',
              }}
              defaultValue={payrollItems.map(payrollItem => payrollItem.id)}
              onChange={onChange}
            >

              {payrollItems.map(payrollItem => (
                <div key={payrollItem.id} style={{marginBottom: 5}}>
                  <Checkbox value={payrollItem.id}>{payrollItem.title}</Checkbox> <br />
                </div>
              ))}

            </Checkbox.Group>
          }
          <Button
            type="primary"
            onClick={fetchReport}
            style={{
              position: "absolute",
              left: 295,
              bottom: 4,
            }}
          >
            {t("text_export")}
          </Button>
        </>
        : <Result
          status="success"
          title={params.get("payrollPeriod") === "first_payment" ? <> Successfully exported  Payroll - 1<sup>st</sup> Payment!</> : <>Successfully exported  Payroll - 2<sup>rd</sup> Payment!</>}
          extra={[
            <div style={{ marginBottom: 25 }}>
              <a key="1" className="ant-btn ant-btn-dashed" href={result ? result.link : "#"}>
                {t("text_download_file_xlsx")}
              </a>
            </div>
          ]}
        />
      )}

    </>
  );
}

export default withDataTable({
  title: "Payroll Report",
  subTitle: "Payrolls",
  backLink: "/reports/payroll",
  showRangeMonthPicker: true,
  showDropdownExport: true,
  menuItems: [
    {
      label: <>Payroll - 1<sup>st</sup> Payment</>,
      param: "first_payment",
    },
    {
      label: <>Payroll - 2<sup>rd</sup> Payment</>,
      param: "second_payment",
    },
  ],
  pathName,
  buttonOption: ExportFormLoader,
  customEmptyMessage: t("text_please_select_date_and_employee"),
  columns,
  componentWillMount,
  footerButton: true,
  handleSearch,
  getData,
});
